/* ══════════════════════════════════════════════════════════════
   LaSirèn — Siren Profile V13
   Measurements + skin tone stay in localStorage on the device.
   Accessibility: focus management, focus trap, Escape, ARIA state.
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var L = window.LaSiren || (window.LaSiren = {});
  var KEY = 'lasiren_profil_v1';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var isFr = String(document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var previousFocus = null;
  var previousOverflow = '';

  var I18N = isFr ? {
    chooseTone: 'Choisis ton ton', inch: 'po', profile: 'Ton profil Sirène : ta taille est ',
    select: 'Sélectionner', selected: '✓ Sélectionné',
    family: {
      nacre: 'Rosé pâle, argent, glacé', sable: 'Rosé et tons chair froids', miel: 'Pêche, corail, or',
      caramel: 'Terracotta, bronze, chrome', cacao: 'Turquoise, prune, or', ebene: 'Blanc, néon, chrome',
      onyx: 'Or, tons précieux, blanc', obsidienne: 'Fuchsia, cobalt, or liquide', jais: 'Néon, blanc pur, chrome'
    }
  } : {
    chooseTone: 'Choose your tone', inch: 'in', profile: 'Your Siren Profile: your size is ',
    select: 'Select', selected: '✓ Selected',
    family: {
      nacre: 'Soft pink, silver, icy tones', sable: 'Rose and cool nude tones', miel: 'Peach, coral, gold',
      caramel: 'Terracotta, bronze, chrome', cacao: 'Turquoise, plum, gold', ebene: 'White, neon, chrome',
      onyx: 'Gold, jewel tones, white', obsidienne: 'Fuchsia, cobalt, liquid gold', jais: 'Neon, pure white, chrome'
    }
  };

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(p) { try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }

  var SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL'];
  var CHART = {
    bust:  [84, 89, 94, 101, 109, 999],
    waist: [64, 69, 74, 81, 89, 97],
    hips:  [89, 94, 99, 106, 114, 122]
  };
  function idxFor(val, arr) { for (var i = 0; i < arr.length; i++) { if (val <= arr[i]) return i; } return arr.length - 1; }
  function computeSize(p) {
    if (!p.bust && !p.waist && !p.hips) return null;
    var idx = 0;
    if (p.bust) idx = Math.max(idx, idxFor(p.bust, CHART.bust));
    if (p.waist) idx = Math.max(idx, idxFor(p.waist, CHART.waist));
    if (p.hips) idx = Math.max(idx, idxFor(p.hips, CHART.hips));
    return SIZES[idx];
  }

  function tons() {
    return L.tons || [
      { id: 'nacre', nom: 'Nacre', hex: '#F2E1CB', swatches: ['#F2E1CB', '#E6C9C9', '#D9D2E0', '#C7D6DE'] },
      { id: 'sable', nom: 'Sable', hex: '#E8C39E', swatches: ['#E8C39E', '#D9A9A0', '#C7B8C9', '#B7C9D1'] },
      { id: 'miel', nom: 'Miel', hex: '#D2A06A', swatches: ['#D2A06A', '#E8A87C', '#F2B33D', '#C97B5A'] },
      { id: 'caramel', nom: 'Caramel', hex: '#B07845', swatches: ['#B07845', '#A85A3C', '#C9A25C', '#8FA9B0'] },
      { id: 'cacao', nom: 'Cacao', hex: '#7A4A2B', swatches: ['#7A4A2B', '#1A7A78', '#6B3B6B', '#E8B84A'] },
      { id: 'ebene', nom: 'Ebony', hex: '#4A2C1A', swatches: ['#4A2C1A', '#F7F2E9', '#7FE8E2', '#9BB0B8'] },
      { id: 'onyx', nom: 'Onyx', hex: '#301A10', swatches: ['#301A10', '#E8B84A', '#1F7A5A', '#F7F2E9'] },
      { id: 'obsidienne', nom: 'Obsidian', hex: '#1C0F09', swatches: ['#1C0F09', '#D6247E', '#2B6DE0', '#E8B84A'] },
      { id: 'jais', nom: 'Jet', hex: '#130A07', swatches: ['#130A07', '#F7F2E9', '#FF3FA4', '#7FE8E2'] }
    ];
  }

  function toneName(t) {
    if (!t) return '';
    if (isFr) return t.nom || t.id;
    var names = { nacre: 'Pearl', sable: 'Sand', miel: 'Honey', caramel: 'Caramel', cacao: 'Cacao', ebene: 'Ebony', onyx: 'Onyx', obsidienne: 'Obsidian', jais: 'Jet' };
    return names[t.id] || t.nom || t.id;
  }
  function toneFamily(t) {
    if (!t) return '—';
    return I18N.family[t.id] || t.famille || '—';
  }

  var modal = $('[data-profile-modal]');
  var unit = 'cm';

  function focusables(root) {
    return $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return !el.hidden && el.offsetParent !== null; });
  }

  function trapFocus(e) {
    if (!modal || !modal.classList.contains('ouvert') || e.key !== 'Tab') return;
    var items = focusables(modal);
    if (!items.length) { e.preventDefault(); modal.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function renderTons(selected) {
    var box = $('[data-profile-tons]', modal);
    if (!box) return;
    box.innerHTML = tons().map(function (t) {
      var label = toneName(t);
      return '<button type="button" class="ls-ton-chip" data-ton="' + t.id + '" title="' + label +
        '" aria-label="' + label + '" style="background:' + t.hex + '" aria-pressed="' + (t.id === selected ? 'true' : 'false') + '"></button>';
    }).join('');
    updateTonNom(selected);
  }
  function updateTonNom(id) {
    var el = $('[data-profile-ton-nom]', modal);
    if (!el) return;
    var t = tons().filter(function (x) { return x.id === id; })[0];
    el.textContent = t ? toneName(t) : I18N.chooseTone;
  }

  function fillForm() {
    if (!modal) return;
    var p = load();
    unit = p.unit || 'cm';
    renderTons(p.ton);
    $$('[data-unit]', modal).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-unit') === unit ? 'true' : 'false'); });
    ['bust', 'waist', 'hips'].forEach(function (k) {
      var input = $('[data-mes="' + k + '"]', modal);
      if (input) input.value = p[k] ? toUnit(p[k]) : '';
    });
    $$('[data-unit-label]', modal).forEach(function (e) { e.textContent = unit === 'cm' ? 'cm' : I18N.inch; });
    showForm();
  }
  function toUnit(cm) { return unit === 'cm' ? Math.round(cm) : Math.round(cm / 2.54 * 10) / 10; }
  function toCm(val) { return unit === 'cm' ? val : val * 2.54; }

  function showForm() {
    var form = $('[data-profile-form]', modal);
    var result = $('[data-profile-result]', modal);
    if (form) form.hidden = false;
    if (result) result.hidden = true;
  }
  function showResult(p) {
    var form = $('[data-profile-form]', modal);
    if (form) form.hidden = true;
    var res = $('[data-profile-result]', modal);
    if (!res) return;
    res.hidden = false;
    $('[data-profile-size]', res).textContent = p.size || '—';
    var t = tons().filter(function (x) { return x.id === p.ton; })[0];
    $('[data-profile-fam]', res).textContent = toneFamily(t);
    var sw = $('[data-profile-swatches]', res);
    if (sw) sw.innerHTML = t && t.swatches ? t.swatches.map(function (h) { return '<span style="background:' + h + '"></span>'; }).join('') : '';
  }

  function open() {
    if (!modal || modal.classList.contains('ouvert')) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    fillForm();
    modal.classList.add('ouvert');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = $('[data-profile-close]', modal) || focusables(modal)[0];
    if (f) f.focus(); else modal.focus();
  }
  function close() {
    if (!modal || !modal.classList.contains('ouvert')) return;
    modal.classList.remove('ouvert');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = previousOverflow;
    if (previousFocus && document.contains(previousFocus) && typeof previousFocus.focus === 'function') previousFocus.focus();
    previousFocus = null;
  }

  function applyProduct() {
    var banner = $('[data-reco-size]');
    if (!banner) return;
    var p = load();
    var opt = p.size ? $('.ls-pp-options .ls-opt[data-option-value="' + p.size + '"]') : null;
    if (!p.size || !opt) { banner.hidden = true; return; }
    banner.hidden = false;
    banner.innerHTML = I18N.profile + '<strong>' + p.size + '</strong>. ' +
      '<button type="button" class="ls-reco-select">' + I18N.select + '</button>';
    var btn = $('.ls-reco-select', banner);
    if (btn) btn.addEventListener('click', function () { opt.click(); btn.textContent = I18N.selected; });
  }

  function markNav() {
    var p = load();
    $$('[data-profile-dot]').forEach(function (d) { d.hidden = !(p.ton || p.size); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-profile]')) { e.preventDefault(); open(); return; }
    if (!modal) return;
    if (e.target.closest('[data-profile-close]')) { close(); return; }
    if (e.target === modal) { close(); return; }

    var chip = e.target.closest('[data-ton]');
    if (chip && modal.contains(chip)) {
      $$('[data-ton]', modal).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', 'true');
      updateTonNom(chip.getAttribute('data-ton'));
      return;
    }
    var u = e.target.closest('[data-unit]');
    if (u && modal.contains(u)) {
      var newUnit = u.getAttribute('data-unit');
      ['bust', 'waist', 'hips'].forEach(function (k) {
        var input = $('[data-mes="' + k + '"]', modal);
        if (input && input.value) {
          var cm = toCm(parseFloat(input.value) || 0);
          unit = newUnit;
          input.value = cm ? toUnit(cm) : '';
        }
      });
      unit = newUnit;
      $$('[data-unit]', modal).forEach(function (b) { b.setAttribute('aria-pressed', b === u ? 'true' : 'false'); });
      $$('[data-unit-label]', modal).forEach(function (el) { el.textContent = unit === 'cm' ? 'cm' : I18N.inch; });
      return;
    }
    if (e.target.closest('[data-profile-save]')) {
      e.preventDefault();
      var selected = $('[data-ton][aria-pressed="true"]', modal);
      var p = { unit: unit, ton: selected ? selected.getAttribute('data-ton') : null };
      ['bust', 'waist', 'hips'].forEach(function (k) {
        var input = $('[data-mes="' + k + '"]', modal);
        var val = input && input.value ? parseFloat(input.value) : 0;
        if (val > 0) p[k] = Math.round(toCm(val));
      });
      p.size = computeSize(p);
      save(p);
      showResult(p);
      applyProduct();
      markNav();
      return;
    }
    if (e.target.closest('[data-profile-edit]')) { fillForm(); return; }
    if (e.target.closest('[data-profile-clear]')) {
      clear(); renderTons(null);
      ['bust', 'waist', 'hips'].forEach(function (k) { var i = $('[data-mes="' + k + '"]', modal); if (i) i.value = ''; });
      showForm(); applyProduct(); markNav(); return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!modal || !modal.classList.contains('ouvert')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    trapFocus(e);
  });

  function boot() {
    var p = load();
    if (modal) modal.setAttribute('aria-hidden', 'true');
    if (modal && (p.size || p.ton)) renderTons(p.ton);
    applyProduct();
    markNav();
    if (L.tons && p.ton) L.profilTon = p.ton;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
